export class EntityState {

	static UPDATED = 'UPDATED';

}
